import { Component, Input, OnChanges, OnDestroy, SecurityContext, SimpleChanges } from '@angular/core';
import { IInternationalMirrorCommittee } from '../../shared/models/international-mirror-committee';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import DOMPurify from 'dompurify';
import { DateFormatPipe } from '../../../controls/pipes/date-format.pipe';


@Component({
    selector: 'app-committee-details-international-participation',
    templateUrl: './committee-details-international-participation.component.html',
    styleUrl: './committee-details-international-participation.component.scss',
    standalone: false
})
export class CommitteeDetailsInternationalParticipationComponent implements OnChanges  {
  @Input() internationalMirrorCommittee: IInternationalMirrorCommittee[] = [];

  sanitizedCommittees: IInternationalMirrorCommittee[] = [];

  constructor(private sanitizer: DomSanitizer, private dateFormatPipe: DateFormatPipe) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['internationalMirrorCommittee'] && changes['internationalMirrorCommittee'].currentValue) {
      const updatedCommittees: IInternationalMirrorCommittee[] = changes['internationalMirrorCommittee'].currentValue;
      this.sanitizedCommittees = this.sanitizeCommitteeFields(updatedCommittees);
    }
  }

  sanitizeCommitteeFields(committees: IInternationalMirrorCommittee[]): IInternationalMirrorCommittee[] {
    return committees.map((committee) => {
      const sanitized: IInternationalMirrorCommittee = { ...committee };

      const fieldsToSanitize: (keyof IInternationalMirrorCommittee)[] = [
        'needForAustralianParticipation',
        'alignmentWithNationalPublicPolicy',
        'netBenefit',
        'harmonisationAndAlignment',
        'comments'
      ];

      fieldsToSanitize.forEach((field) => {
        const value = committee[field];
        if (typeof value === 'string') {
          const formatValue = this.applyDisplayDash(committee[field] as string);
          const purified = DOMPurify.sanitize(formatValue);
          (sanitized as any)[field] =  this.sanitizer.bypassSecurityTrustHtml(purified) as SafeHtml;
        }
      });

      if (committee.caseExpiryDate) {
        const formattedDate = this.dateFormatPipe.transform(committee.caseExpiryDate);
        const purifiedDate = DOMPurify.sanitize(`<span>${formattedDate}</span>`);
        (sanitized as any)['caseExpiryDate'] = this.sanitizer.bypassSecurityTrustHtml(purifiedDate) as SafeHtml;
      }

      return sanitized as IInternationalMirrorCommittee;
    });
  }

  applyDisplayDash (value: string | null | undefined): string {
    return value && value.trim() !== '' ? value.trim() : '-';
  }


}
